import "./couple.css";
const PhotoCouple = ({ values }) => {

  const renderPersonCard = ({
    image,
    alt,
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    if (!image?.url) return null;

    const baseUrl = image.url;

    return (
      <div className="t1-couple-person">

        <div className="t1-couple-grandparents">
          {grandParentsName && (
            <p>
              {grandParentsPrefix} {grandParentsName}
            </p>
          )}
        </div>
        <img
          src={baseUrl}
          alt={alt}
          srcSet={`
              ${baseUrl.replace("/upload/", "/upload/w_320/")} 320w,
              ${baseUrl.replace("/upload/", "/upload/w_640/")} 640w,
              ${baseUrl.replace("/upload/", "/upload/w_1080/")} 1080w
            `}
          sizes="
              (max-width: 320px) 320px,
              (max-width: 640px) 640px,
              (max-width: 1080px) 1080px
            "
          className="t1-couple-image"
        />

        <h1 className="t1-couple-name">
          {fullname}
        </h1>

        <div className="t1-couple-parents">
          {parentsName && (
            <p>
              {parentprefix} {parentsName}
            </p>
          )}
        </div>



      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      image: values.groomImage,
      alt: "groomImage",
      fullname: values.groomFullName || "Groom Full Name",
      parentprefix: values.groomParentsPrefix,
      parentsName: values.groomParents,
      grandParentsPrefix: values.groomGrandParentsPrefix,
      grandParentsName: values.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      image: values.brideImage,
      alt: "brideImage",
      fullname: values.brideFullName || "Bride Full Name",
      parentprefix: values.brideParentsPrefix,
      parentsName: values.brideParents,
      grandParentsPrefix: values.brideGrandParentsPrefix,
      grandParentsName: values.brideGrandParents,
    });

  return (
    <div className="t1-couple-section t1-photo-couple">

      <img
        src="couple-section-flower.png"
        className="t1-couple-corner t1-top-left"
        alt=""
      />

      <img
        src="couple-section-flower.png"
        className="t1-couple-corner t1-top-right"
        alt=""
      />

      <img
        src="couple-section-flower.png"
        className="t1-couple-corner t1-bottom-left"
        alt=""
      />

      <img
        src="couple-section-flower.png"
        className="t1-couple-corner t1-bottom-right"
        alt=""
      />

      <h1 className="t1-couple-heading">
        {values.sectionHeading}
      </h1>

      <div className="t1-couple-wrapper">

        {values.displayOrder === "groomFirst" ? (
          <>
            {groomCard()}

            <span className="t1-couple-divider">
              &
            </span>

            {brideCard()}
          </>
        ) : (
          <>
            {brideCard()}

            <span className="t1-couple-divider">
              &
            </span>

            {groomCard()}
          </>
        )}

      </div>

    </div>
  );
};

export default PhotoCouple;